var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cprod-notes-component',{attrs:{"tag":"u-contextualise"}}),_vm._v(" "),_c('cprod-secrets-component',{attrs:{"tag":"u-contextualise"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }